import * as Events from '@shoflo/studio-redux/constants/SocketEvents';
import BaseSocketDispatcher from '@shoflo/studio-redux/SocketDispatcher/SocketDispatcher';
import { MIXER_TASK_FAILED } from '@studio/constants/SocketEvents';
import _ from 'underscore';

import cancelAttendeeScreen from './handlers/cancelAttendeeScreen';
import removeAttendeeScreen from './handlers/removeAttendeeScreen';
import processRealTimeMessage from './handlers/processRealTimeMessage';
import knockUpdated from './handlers/knockUpdated';
import mixerTaskFailed from './handlers/mixerTaskFailed';
import programChanged from './handlers/programChanged';
import socketConnected from './handlers/socketConnection/socketConnected';
import socketDisconnected from './handlers/socketConnection/socketDisconnected';
import socketReconnected from './handlers/socketConnection/socketReconnected';
import agoraScreenShareStopped from './handlers/agoraScreenShareStopped';

import toggledAgoraPresenterLive from './handlers/toggledAgoraPresenterLive';

class SocketDispatcher extends BaseSocketDispatcher {
  /**
   * Register app-specific event-handlerFn mappings here. You may override
   * any mappings defined in the _defaultEventHandlerMap.
   *
   * @type {Object.<{"string": function(store, data): void}>}
   */

  _appEventHandlerMap = {
    [Events.REAL_TIME]: processRealTimeMessage,
    [Events.ATTENDEE_SCREEN_SHARE_CANCELLED]: cancelAttendeeScreen,
    [Events.KNOCK_UPDATED]: knockUpdated,
    [Events.BROADCAST_PROGRAM_CHANGED]: programChanged,
    [Events.BROADCAST_PROGRAM_SYNCED]: programChanged,
    [Events.CONNECT]: socketConnected,
    [Events.DISCONNECT]: socketDisconnected,
    [Events.RECONNECT]: socketReconnected,
    [Events.ATTENDEE_LEFT]: _.debounce(removeAttendeeScreen, 2000),
    [Events.AGORA_SCREEN_SHARE_STOPPED]: agoraScreenShareStopped,
    [Events.TOGGLED_AGORA_PRESENTER_LIVE]: toggledAgoraPresenterLive,
    [MIXER_TASK_FAILED]: mixerTaskFailed
  };
}

export default SocketDispatcher;
